const baseApiUrl = {
  DataPageUrl: '/support/baseApi/page',
  DataGridUrl: '/support/baseApi/grid',
  DataStepUrl: '/support/baseApi/step',
  DataTabsUrl: '/support/baseApi/tabs',
  DataTreeUrl: '/support/baseApi/tree',
  DataTileUrl: '/support/baseApi/tile',
  DataConfigSaveUrl: '/support/baseApi/config/save',
  DataConfigLoadUrl: '/support/baseApi/config/load'
}

export default baseApiUrl
